/** @format */

import React from "react";
import { useDispatch} from "react-redux";
import { toggle } from "../common/Store/sidebarSlice";

const HeaderWrapper = ({ children }) => {
  const dispatch = useDispatch();


  const handleToggle = () => {
    dispatch(toggle());
  };

  return (
    <>
      <nav id="header" className="sticky top-0 lg:pl-10 w-full bg-white">
        <div className="px-2 py-5 md:px-5 lg:pl-3">
          <div className="flex align-center justify-between ">
            <button
              onClick={handleToggle}
              className="flex items-center mr-3 lg:mr-0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 cursor-pointer lg:hidden "
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                ></path>
              </svg>
            </button>
            {children}
          </div>
        </div>
      </nav>
    </>
  );
};

export default HeaderWrapper;
